<layout>

  <div class="background inset" [@title]=currentState>
      <div [@title]=currentState>
        <h1>{{config?.myLessonsTitle}}</h1>
        <p>{{config?.mylessonsSubtitle}}</p>
        <text-button 
          *ngIf="!profile?.uid"
          (click)=register()
          color="rgba(0, 0, 0, 0.6)" 
          highlight="rgba(0, 0, 0, 0.3)">{{config?.mainStartButton}}</text-button>
        <div class = "horizontalLine"></div>
      </div>
      <div class="inner">
        <app-lesson-blocks 
        authLevel="{{authLevel}}"
        (onLessonChoice)="sendTitleOut();"></app-lesson-blocks>
      </div>
    </div>
  
  </layout>